import LockupLastUpdated from './lockupLastUpdated'

export default LockupLastUpdated
